'use client'
import { Switcher, SwitcherId, SwitcherProps } from '../../../molecules/Switcher'
import { useFilterContext } from '../../../../providers'
import { FilterOperator, FilterValue } from '../../../../types/Filters'
import React, { useEffect, useState } from 'react'

export interface SwitcherFilterProps extends SwitcherProps {
    /** "name" of object that should be filtered on. Will be used to create unique ID for "Filter" Object. This should be exactly the key that the API needs to filter on */
    name: string
    isLoading?: boolean
}

const OPERATOR = FilterOperator.EQUALS

export const SwitcherFilter = ({
    name,
    items,
    initialItem,
    onSwitch,
    isLoading = false,
    ...props
}: SwitcherFilterProps): JSX.Element => {
    const { filters, registerFilter, updateFilterValue, getFilterId, getFilterValue, getFilterById } =
        useFilterContext()
    const filterId = getFilterId(name, OPERATOR)

    const [selectedValue, setSelectedValue] = useState<FilterValue>(getFilterValue(filterId) ?? items[0]?.id)

    useEffect(() => {
        registerFilter({
            id: filterId,
            key: name,
            operator: OPERATOR,
            value: selectedValue,
            nonClearable: true,
        })
    }, [])

    useEffect(() => {
        const filter = getFilterById(filterId)
        if (filter && filter.value !== selectedValue) {
            updateFilterValue({ filter: filter, newValue: selectedValue })
        }
    }, [selectedValue])

    useEffect(() => {
        const filter = getFilterById(filterId)
        if (filter) {
            const matchingFilter = filters.find((stateFilter) => stateFilter.id === filter.id)
            if (matchingFilter && selectedValue !== matchingFilter?.value) {
                setSelectedValue(matchingFilter.value)
            }
        }
    }, [filters])

    const onSwitchHandler = (id: string | number): void => {
        setSelectedValue(id)
    }

    return (
        <>
            <Switcher
                items={items}
                initialItem={selectedValue as SwitcherId | null}
                onSwitch={onSwitchHandler}
                isLoading={isLoading}
                {...props}
            />
        </>
    )
}
